// extracted by mini-css-extract-plugin
module.exports = {"tableActionButtons":"Tables_tableActionButtons__3gYlf","exelButton":"Tables_exelButton__2yCBW","tableWrapper":"Tables_tableWrapper__V6Oko"};